import styled from "styled-components";
import ChangePasswordComp from "components/client/settings/ChangePassword";

const ChangePassword = () => {
  return (
    <ChangePasswordContainer>
      <ChangePasswordComp />
    </ChangePasswordContainer>
  );
};

export default ChangePassword;

export const ChangePasswordContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  grid-gap: 40px;
  background: #fff;
  width: 100%;
  padding: 20px;
  min-height: 85vh;
`;
